export function GpaScaleTable() {
    return (
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-300">
          <thead>
            <tr className="bg-gray-100">
              <th className="py-2 px-4 border-b">Letter Grade</th>
              <th className="py-2 px-4 border-b">4.0 Scale</th>
              <th className="py-2 px-4 border-b">5.0 Scale</th>
              <th className="py-2 px-4 border-b">100-Point Scale</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="py-2 px-4 border-b">A+</td>
              <td className="py-2 px-4 border-b">4.0</td>
              <td className="py-2 px-4 border-b">5.0</td>
              <td className="py-2 px-4 border-b">97-100</td>
            </tr>
            <tr>
              <td className="py-2 px-4 border-b">A</td>
              <td className="py-2 px-4 border-b">4.0</td>
              <td className="py-2 px-4 border-b">4.7</td>
              <td className="py-2 px-4 border-b">93-96</td>
            </tr>
            <tr>
              <td className="py-2 px-4 border-b">A-</td>
              <td className="py-2 px-4 border-b">3.7</td>
              <td className="py-2 px-4 border-b">4.3</td>
              <td className="py-2 px-4 border-b">90-92</td>
            </tr>
            <tr>
              <td className="py-2 px-4 border-b">B+</td>
              <td className="py-2 px-4 border-b">3.3</td>
              <td className="py-2 px-4 border-b">4.0</td>
              <td className="py-2 px-4 border-b">87-89</td>
            </tr>
            <tr>
              <td className="py-2 px-4 border-b">B</td>
              <td className="py-2 px-4 border-b">3.0</td>
              <td className="py-2 px-4 border-b">3.7</td>
              <td className="py-2 px-4 border-b">83-86</td>
            </tr>
            <tr>
              <td className="py-2 px-4 border-b">B-</td>
              <td className="py-2 px-4 border-b">2.7</td>
              <td className="py-2 px-4 border-b">3.3</td>
              <td className="py-2 px-4 border-b">80-82</td>
            </tr>
            <tr>
              <td className="py-2 px-4 border-b">C+</td>
              <td className="py-2 px-4 border-b">2.3</td>
              <td className="py-2 px-4 border-b">3.0</td>
              <td className="py-2 px-4 border-b">77-79</td>
            </tr>
            <tr>
              <td className="py-2 px-4 border-b">C</td>
              <td className="py-2 px-4 border-b">2.0</td>
              <td className="py-2 px-4 border-b">2.7</td>
              <td className="py-2 px-4 border-b">73-76</td>
            </tr>
            <tr>
              <td className="py-2 px-4 border-b">C-</td>
              <td className="py-2 px-4 border-b">1.7</td>
              <td className="py-2 px-4 border-b">2.3</td>
              <td className="py-2 px-4 border-b">70-72</td>
            </tr>
            <tr>
              <td className="py-2 px-4 border-b">D+</td>
              <td className="py-2 px-4 border-b">1.3</td>
              <td className="py-2 px-4 border-b">2.0</td>
              <td className="py-2 px-4 border-b">67-69</td>
            </tr>
            <tr>
              <td className="py-2 px-4 border-b">D</td>
              <td className="py-2 px-4 border-b">1.0</td>
              <td className="py-2 px-4 border-b">1.7</td>
              <td className="py-2 px-4 border-b">63-66</td>
            </tr>
            <tr>
              <td className="py-2 px-4 border-b">D-</td>
              <td className="py-2 px-4 border-b">0.7</td>
              <td className="py-2 px-4 border-b">1.3</td>
              <td className="py-2 px-4 border-b">60-62</td>
            </tr>
            <tr>
              <td className="py-2 px-4 border-b">F</td>
              <td className="py-2 px-4 border-b">0.0</td>
              <td className="py-2 px-4 border-b">0.0</td>
              <td className="py-2 px-4 border-b">0-59</td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
  
  